// extracted by mini-css-extract-plugin
module.exports = {"iconArrow":"bubbleFlowArrows_iconArrow___UwYW","noHover":"bubbleFlowArrows_noHover__avnys"};